import { TextInput } from "../form";
import { useSearchForm } from "../hooks";
import { useTranslation } from "../localization";

export function TimelineSearch() {
	const methods = useSearchForm();
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="w-[400px]">
			<TextInput
				label={undefined}
				control={methods.control}
				name="searchValue"
				isRequired={false}
				type="search"
				placeholder={t("placeholders.search")}
			/>
		</div>
	);
}
